<app-modal [title]="'Lead Details' ">
  <div ngbAutoFocus class="modal-content pt-0" style="overflow: visible">
    <div *ngIf="viewStatus === 1">
      <app-shimmer-view [viewType]="'form'"></app-shimmer-view>
    </div>

    <div *ngIf="viewStatus === 0">
      <ng-container *ngIf="lead">
        <div class="list">

          <div class="item first-item">
            <div class="line w-50">
              <span class="title">
                <i class="ti ti-user"></i>
                {{ 'Name' }}
              </span>
              <span class="desc">{{ lead | leadName }}</span>
            </div>

            <div class="line w-50">
              <span class="title">
                <i class="ti ti-tag"></i>
                {{ 'Lead Type' }}
              </span>
              <span class="desc">{{ formattedLeadType }}</span>
            </div>
          </div>

          <div class="item">
            <div class="line w-50">
              <span class="title">
                <i class="ti ti-phone"></i>
                {{ 'Phone Number' }}
              </span>
              <span class="desc d-flex align-items-center">
                {{ lead.phoneNumber }}
                <app-verified-icon [verifiedAt]="lead.phoneNumberVerifiedAt"></app-verified-icon>
              </span>
            </div>

            <div class="line w-50">
              <span class="title">
                <i class="ti ti-mail"></i>
                {{ 'Email' }}
              </span>
              <span class="desc d-flex align-items-center">
                {{ lead.email }}
                <app-verified-icon [verifiedAt]="lead.emailVerifiedAt"></app-verified-icon>
              </span>
            </div>
          </div>

          <div class="item" *ngIf="lead.address">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-home"></i>
                {{ 'Address' }}
              </span>
              <span class="desc">{{ lead.address }}</span>
            </div>
          </div>

          <div class="item" *ngIf="formattedLocation || formattedLeadStatus">
            <div class="line w-50" *ngIf="formattedLocation">
              <span class="title">
                <i class="ti ti-map-pin"></i>
                {{ 'Location' }}
              </span>
              <span class="desc">{{ formattedLocation }}</span>
            </div>

            <div class="line w-50" *ngIf="formattedLeadStatus">
              <span class="title">
                <i class="ti ti-status-change"></i>
                {{ 'Status' }}
              </span>
              <span class="desc">{{ formattedLeadStatus }}</span>
            </div>
          </div>

          <div class="item">
            <div class="line w-50">
              <span class="title">
                <i class="ti ti-calendar-plus"></i>
                {{ 'Created At' }}
              </span>
              <span class="desc">{{ lead.createdAt | date:'dd/MM/yyyy HH:mm':'':'en-US' }}</span>
            </div>

            <div class="line w-50">
              <span class="title">
                <i class="ti ti-calendar-check"></i>
                {{ 'Updated At' }}
              </span>
              <span class="desc">{{ lead.updatedAt | date:'dd/MM/yyyy HH:mm':'':'en-US' }}</span>
            </div>
          </div>

          <div class="item" *ngIf="lead.disabledAt">
            <div class="line w-50">
              <span class="title text-danger">
                <i class="ti ti-ban"></i>
                {{ 'Disabled At' }}
              </span>
              <span class="desc">{{ lead.disabledAt | date:'dd/MM/yyyy HH:mm':'':'en-US' }}</span>
            </div>
          </div>

          <div class="item">
            <div class="line w-50">
              <span class="title">
                <i class="ti ti-broadcast"></i>
                {{ 'Source' }}
              </span>
              <span class="desc">
                <span [class]="leadSourceBadgeClass + ' badge'">{{ formattedLeadSource }}</span>
              </span>
            </div>

            <div class="line w-50"
              ngbTooltip="Indicates whether the lead already has an associated quote or contact request"
              placement="top">
              <span class="title">
                <i class="ti ti-file-check"></i>
                {{ 'Has Request' }}
              </span>
              <span class="desc">
                <span *ngIf="lead.hasRequest === true" class="badge bg-success text-white">
                  <i class="ti ti-check me-1"></i>Yes
                </span>
                <span *ngIf="lead.hasRequest === false || lead.hasRequest == null" class="badge bg-danger text-white">
                  <i class="ti ti-x me-1"></i>No
                </span>
              </span>
            </div>
          </div>

          <div class="item" *ngIf="lead.partnerName">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-building"></i>
                {{ 'Partner' }}
              </span>
              <span class="desc">{{ lead.partnerName }}</span>
            </div>
          </div>

          <div class="item" *ngIf="lead.quoteRequestCountry || lead.quoteRequestRegion || lead.quoteRequestDistrict">
            <div class="line w-100">
              <span class="title">
                <i class="ti ti-map-pin"></i>
                {{ 'Treatment Location' }}
              </span>
              <span class="desc">{{ formattedQuoteRequestLocation }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <div *ngIf="!lead" class="text-center py-4">
        <p class="text-muted">{{ 'Lead not found' }}</p>
      </div>
    </div>
  </div>
</app-modal>